module.exports = __webpack_public_path__ + "img/8.3b4f33b6.jpg";